// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsletter{
    width: 65%;
    height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
margin: auto;
padding: 0px 140px;
margin-bottom: 150px;
background: linear-gradient(180deg, #fde1ff 0%, #e1ffea22 60% );
gap: 30px;

}
.newsletter h1{
    color: #454545;
    font-size: 55px;
    font-weight: 600;

}
.newsletter p{
    color: #454545;
    font-size: 20px;

}
.newsletter div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    width: 730px;
    height: 70px;
    border-radius: 80px;
    border: 1px solid #e3e3e3;


}
.newsletter input{
    width: 500px;
    margin-left: 30px;
    border: none;
    outline: none;
    color: #616161;
    font-family: poppins;
    font-size: 16px;
}
.newsletter div button{
    width: 210px;
    height: 70px;
    border-radius: 80px;
    background: black;
    color: white;
    font-size: 16px;
    cursor: pointer;
}
@media(max-width:1280px){
    .newsletter{
        padding: 0px 80px;
        margin-bottom: 120px;
        gap: 20px;
    }
    .newsletter h1{
        font-size: 36px;
    }
    .newsletter p{
        font-size: 16px;
    }
    .newsletter div{
        width: 600px;
        height: 60px;
    }
    .newsletter div input{
        width: 400px;

    }
    .newsletter div button{
        width: 160px;
        height: 60px;
        
    }
}
@media(max-width:1024px){
    .newsletter{
       
        margin-bottom: 60px;
       
    }
    .newsletter h1{
        font-size: 30px;
    }
    .newsletter p{
        font-size: 14px;
    }
    .newsletter div{
        width: 500px;
        height: 50px;
    }
    .newsletter div input{
        width: 300px;
        font-size: 14px;

    }
    .newsletter div button{
        width: 120px;
        height: 50px;
        font-size: 14px;

    }
}
@media(max-width:800px){
    .newsletter{
       
        margin-bottom: 30px;
        height: 35vh;
        gap: 20px;
    }
    .newsletter h1{
        font-size: 18px;
    }
    .newsletter p{
        font-size: 12px;
    }
    .newsletter div{
        width: 400px;
        height: 40px;
    }
    .newsletter div input{
        width: 200px;
        font-size: 13px;

    }
    .newsletter div button{
        width: 100px;
        height: 40px;
        font-size: 13px;

    }
}
@media(max-width:500px){
    .newsletter{
       height: 25vh;
       width: 100%;
        padding: 0;
        gap: 15px;
    }
    .newsletter h1{
        font-size: 16px;
    }
    .newsletter p{
        font-size: 13px;
        max-width: 200px;
        text-align: center;
    }
    .newsletter div{
        width: 290px;
        height: 40px;
    }
    .newsletter div input{
        width: 130px;


    }
   
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewsLetter/NewsLetter.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B,YAAY;AACZ,kBAAkB;AAClB,oBAAoB;AACpB,+DAA+D;AAC/D,SAAS;;AAET;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,cAAc;IACd,eAAe;;AAEnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;;;AAG7B;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;;IAEhB;IACA;QACI,YAAY;QACZ,YAAY;;IAEhB;AACJ;AACA;IACI;;QAEI,mBAAmB;;IAEvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;QACZ,eAAe;;IAEnB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;;IAEnB;AACJ;AACA;IACI;;QAEI,mBAAmB;QACnB,YAAY;QACZ,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;QACZ,eAAe;;IAEnB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;;IAEnB;AACJ;AACA;IACI;OACG,YAAY;OACZ,WAAW;QACV,UAAU;QACV,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;;;IAGhB;;AAEJ","sourcesContent":[".newsletter{\n    width: 65%;\n    height: 40vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\nmargin: auto;\npadding: 0px 140px;\nmargin-bottom: 150px;\nbackground: linear-gradient(180deg, #fde1ff 0%, #e1ffea22 60% );\ngap: 30px;\n\n}\n.newsletter h1{\n    color: #454545;\n    font-size: 55px;\n    font-weight: 600;\n\n}\n.newsletter p{\n    color: #454545;\n    font-size: 20px;\n\n}\n.newsletter div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: white;\n    width: 730px;\n    height: 70px;\n    border-radius: 80px;\n    border: 1px solid #e3e3e3;\n\n\n}\n.newsletter input{\n    width: 500px;\n    margin-left: 30px;\n    border: none;\n    outline: none;\n    color: #616161;\n    font-family: poppins;\n    font-size: 16px;\n}\n.newsletter div button{\n    width: 210px;\n    height: 70px;\n    border-radius: 80px;\n    background: black;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n}\n@media(max-width:1280px){\n    .newsletter{\n        padding: 0px 80px;\n        margin-bottom: 120px;\n        gap: 20px;\n    }\n    .newsletter h1{\n        font-size: 36px;\n    }\n    .newsletter p{\n        font-size: 16px;\n    }\n    .newsletter div{\n        width: 600px;\n        height: 60px;\n    }\n    .newsletter div input{\n        width: 400px;\n\n    }\n    .newsletter div button{\n        width: 160px;\n        height: 60px;\n        \n    }\n}\n@media(max-width:1024px){\n    .newsletter{\n       \n        margin-bottom: 60px;\n       \n    }\n    .newsletter h1{\n        font-size: 30px;\n    }\n    .newsletter p{\n        font-size: 14px;\n    }\n    .newsletter div{\n        width: 500px;\n        height: 50px;\n    }\n    .newsletter div input{\n        width: 300px;\n        font-size: 14px;\n\n    }\n    .newsletter div button{\n        width: 120px;\n        height: 50px;\n        font-size: 14px;\n\n    }\n}\n@media(max-width:800px){\n    .newsletter{\n       \n        margin-bottom: 30px;\n        height: 35vh;\n        gap: 20px;\n    }\n    .newsletter h1{\n        font-size: 18px;\n    }\n    .newsletter p{\n        font-size: 12px;\n    }\n    .newsletter div{\n        width: 400px;\n        height: 40px;\n    }\n    .newsletter div input{\n        width: 200px;\n        font-size: 13px;\n\n    }\n    .newsletter div button{\n        width: 100px;\n        height: 40px;\n        font-size: 13px;\n\n    }\n}\n@media(max-width:500px){\n    .newsletter{\n       height: 25vh;\n       width: 100%;\n        padding: 0;\n        gap: 15px;\n    }\n    .newsletter h1{\n        font-size: 16px;\n    }\n    .newsletter p{\n        font-size: 13px;\n        max-width: 200px;\n        text-align: center;\n    }\n    .newsletter div{\n        width: 290px;\n        height: 40px;\n    }\n    .newsletter div input{\n        width: 130px;\n\n\n    }\n   \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
